import { jsx as _jsx } from "react/jsx-runtime";
import { getImageUrl } from "@msys/common";
import { ImageList } from "@mui/material";
import { is3dModel, isImage, } from "../attachments/helpers.js";
import { ImageListItem } from "../image/ImageListItem.js";
import { ThreeDGenericImage } from "../threeD/ThreeDGenericImage.js";
const DEFAULT_IMAGE_SIZE = 240; // TODO: is this a good generic value
export const GalleryCol = ({ images, handleClick, maxItems, selectedIndex, imageWidth, containerHeight, aspectRatio, style, idPrefix = "msys-gallery-col-", }) => {
    const imagesList = maxItems ? images.slice(0, maxItems) : images;
    const height = containerHeight ??
        (maxItems
            ? "100%"
            : imageWidth
                ? images.length * imageWidth + (images.length - 1) * 4
                : "100%");
    const width = imageWidth;
    const containerAspectRatio = containerHeight && !imageWidth && imagesList.length > 0
        ? `${(containerHeight - (imagesList.length - 1) * 4) / imagesList.length} / ${containerHeight}`
        : undefined;
    return images.length > 0 ? (_jsx(ImageList, { style: {
            height,
            width: width ?? "auto",
            aspectRatio: containerAspectRatio,
            flexGrow: 0,
            flexShrink: 0,
            userSelect: "none",
            ...style,
        }, cols: 1, rowHeight: "auto", children: imagesList.map((image, index) => {
            const isMoreAmount = Boolean(maxItems &&
                images.length > maxItems &&
                index === imagesList.length - 1);
            return (_jsx(ImageListItem, { id: `${idPrefix}${image.id}`, onClick: handleClick
                    ? e => {
                        e.stopPropagation();
                        handleClick(index, image, isMoreAmount);
                    }
                    : undefined, role: Boolean(handleClick) && selectedIndex !== index
                    ? "button"
                    : "initial", "$clickable": true, "$selected": selectedIndex === index, "$moreAmount": isMoreAmount ? Math.min(images.length - maxItems, 99) : undefined, "$aspectRatio": aspectRatio, children: isImage(image) ? (_jsx("img", { draggable: false, src: getImageUrl({
                        url: image.url,
                        width: width ?? DEFAULT_IMAGE_SIZE,
                    }), srcSet: `${getImageUrl({
                        url: image.url,
                        width: width ?? DEFAULT_IMAGE_SIZE,
                        scaling: 2,
                    })} 2x`, alt: image.title, loading: "lazy" })) : is3dModel(image) ? (_jsx(ThreeDGenericImage, {})) : null }, image.id));
        }) })) : null;
};
//# sourceMappingURL=GalleryCol.js.map